import { render, staticRenderFns } from "./mba.vue?vue&type=template&id=634492b2&scoped=true"
import script from "./mba.vue?vue&type=script&lang=ts"
export * from "./mba.vue?vue&type=script&lang=ts"
import style0 from "./mba.vue?vue&type=style&index=0&id=634492b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634492b2",
  null
  
)

export default component.exports